module.exports = __webpack_public_path__ + "static/media/logo-samsung@2x.68790fba.png";